module.exports = __webpack_public_path__ + "static/img/bg.3cd0ebe3.jpg";